import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=609bf5cb&"
import script from "./ArticlesList.vue?vue&type=script&lang=js&"
export * from "./ArticlesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports